import React from 'react';
import { GlueProvider } from '@glue42/react-hooks';
import { glue42Settings } from './settings';
import { useIndigoGlue } from 'app/glue/useIndigoGlue';
import { useLogger } from 'logging/writers/hooks';
import { isQueryParameterPresent } from '@instinet-analytics/core-lib';

export function GlueSupport() {
    const usingGlue = isQueryParameterPresent('glue', ['1', 'true']);
    const logger = useLogger('GlueSupport');

    if (!usingGlue) {
        logger.info('Not using Glue');
        return <></>;
    }

    logger.info('Using Glue');

    return (
        <GlueProvider settings={glue42Settings}>
            <Glue42Content />
        </GlueProvider>
    );
}

export function Glue42Content() {
    useIndigoGlue();

    return <></>;
}
